module.exports = __webpack_public_path__ + "img/MarketStat.b49f9a1.jpg";